{
  "v5.m2.annuler": "Annuler",
  "v5.m2.anomalie.anomalie": "l’anomalie",
  "v5.m2.anomalie.aucune_campagne": "Aucune campagne.",
  "v5.m2.anomalie.aucune_preuve": "Aucune exécution verte du cas lié après la résolution.",
  "v5.m2.anomalie.campagne": "Campagne",
  "v5.m2.anomalie.campagne_a_choisir": "Choisissez une campagne pour voir les exécutions éligibles.",
  "v5.m2.anomalie.campagnes": "les campagnes",
  "v5.m2.anomalie.choisir": "Choisir…",
  "v5.m2.anomalie.consulter_execution": "Consulter l’exécution",
  "v5.m2.anomalie.echec": "Le changement d’état a échoué.",
  "v5.m2.anomalie.enregistrer_examen": "Enregistrer l’examen",
  "v5.m2.anomalie.etat.closed": "fermée",
  "v5.m2.anomalie.etat.duplicate": "doublon",
  "v5.m2.anomalie.etat.in_progress": "en correction",
  "v5.m2.anomalie.etat.new": "nouvelle",
  "v5.m2.anomalie.etat.not_reproducible": "non reproductible",
  "v5.m2.anomalie.etat.rejected": "rejetée",
  "v5.m2.anomalie.etat.reopened": "rouverte",
  "v5.m2.anomalie.etat.resolved": "résolue",
  "v5.m2.anomalie.etat.triaged": "qualifiée",
  "v5.m2.anomalie.etat.verified": "vérifiée",
  "v5.m2.anomalie.examinee": "Examen enregistré : l’anomalie est vérifiée.",
  "v5.m2.anomalie.execution": "Exécution prouvant la correction",
  "v5.m2.anomalie.executions": "les exécutions",
  "v5.m2.anomalie.fermee": "Anomalie fermée.",
  "v5.m2.anomalie.fermer": "Fermer l’anomalie",
  "v5.m2.anomalie.observation": "Observation",
  "v5.m2.anomalie.observation_requise": "L’observation est requise pour l’examen.",
  "v5.m2.anomalie.pas_resolue": "L’anomalie n’est pas résolue.",
  "v5.m2.anomalie.pas_verifiee": "L’anomalie doit d’abord être vérifiée.",
  "v5.m2.anomalie.preuve_aide": "Distincte de l’exécution verte : version livrée, déploiement ou publication.",
  "v5.m2.anomalie.preuve_livraison": "Preuve de livraison",
  "v5.m2.anomalie.preuve_requise": "La preuve de livraison est requise pour fermer.",
  "v5.m2.anomalie.refaire": "Refaire l’exécution",
  "v5.m2.anomalie.resolue_par": "Résolue par {{qui}} le {{le}}.",
  "v5.m2.anomalie.resolveur": "Vous avez résolu cette anomalie : une autre personne la vérifie.",
  "v5.m2.anomalie.sans_anomalie": "Aucune anomalie n’est désignée : ouvrez ce dialogue depuis une anomalie.",
  "v5.m2.anomalie.titre": "Vérifier puis fermer une anomalie",
  "v5.m2.code.ACCESS_DENIED": "L’accès à ce geste vous est refusé.",
  "v5.m2.code.CAS_DEJA_EN_QUARANTAINE": "Ce cas est déjà en quarantaine.",
  "v5.m2.code.CAS_PAS_EN_QUARANTAINE": "Ce cas n’est pas en quarantaine.",
  "v5.m2.code.CONTEXTE_INCOMPLET": "Le contexte de la décision est incomplet.",
  "v5.m2.code.CREATEUR_N_APPROUVE_PAS": "L’auteur ne peut pas décider de son propre travail.",
  "v5.m2.code.DEFECT_TRANSITION_FORBIDDEN": "Ce changement d’état n’est pas permis.",
  "v5.m2.code.DEFECT_VERIFICATION_REQUIRES_GREEN_EXECUTION": "Il faut une exécution verte du cas lié, après la résolution.",
  "v5.m2.code.DEFECT_VERIFIER_NOT_INDEPENDENT": "La personne qui a résolu l’anomalie ne la vérifie pas.",
  "v5.m2.code.DROIT_NON_TENU": "Vous ne tenez pas le droit qu’exige ce geste.",
  "v5.m2.code.HITL_SOD_AUTHOR_CANNOT_DECIDE": "Le proposant de l’outil ne le décide pas.",
  "v5.m2.code.MISSION_ALREADY_PAUSED": "La mission est déjà en pause.",
  "v5.m2.code.MISSION_ALREADY_SUSPENDED": "La mission est déjà suspendue.",
  "v5.m2.code.MISSION_DECISION_ALREADY_TAKEN": "Cette décision a déjà été prise.",
  "v5.m2.code.MISSION_ESCALATION_BUDGET_EXHAUSTED": "Le budget de réouvertures de la mission est épuisé.",
  "v5.m2.code.MISSION_NOT_AWAITING_APPROVAL": "La mission n’attend pas de décision.",
  "v5.m2.code.MISSION_NOT_PAUSED": "La mission n’est pas en pause.",
  "v5.m2.code.MISSION_NOT_RUNNING": "La mission n’est pas en cours.",
  "v5.m2.code.MISSION_TASK_NOT_FOUND": "Cette tâche n’appartient pas à la mission.",
  "v5.m2.code.NOT_FOUND": "Introuvable dans ce projet.",
  "v5.m2.code.RELECTEUR_NE_DECIDE_PAS": "Le relecteur ne décide pas.",
  "v5.m2.code.SELF_APPROVAL_REFUSED": "Le lanceur de la mission ne la décide pas.",
  "v5.m2.code.SOD_VIOLATION": "L’auteur de la suite ne l’exécute pas : demandez à un autre membre.",
  "v5.m2.code.TOOL_EXECUTION_ALREADY_DECIDED": "Cette exécution d’outil est déjà décidée.",
  "v5.m2.code.TOOL_EXECUTION_NOT_FOUND": "Demande d’exécution d’outil introuvable.",
  "v5.m2.code.VALIDATION_ERROR": "La saisie est refusée : vérifiez les champs.",
  "v5.m2.decider.approuver": "Approuver",
  "v5.m2.decider.approuver_plan": "Approuver le plan",
  "v5.m2.decider.approuver_replan": "Approuver le nouveau découpage",
  "v5.m2.decider.consommation": "Budget : {{minutes}} min de calcul, {{consomme}} min consommées.",
  "v5.m2.decider.decide": "Décision enregistrée.",
  "v5.m2.decider.decider_partiellement": "Livrer les tâches abouties",
  "v5.m2.decider.decider_suite": "Décider la suite",
  "v5.m2.decider.dossier_non_servi": "Le dossier n’est pas servi : il ne peut pas être approuvé à l’aveugle.",
  "v5.m2.decider.echec": "La décision n’a pas pu être enregistrée.",
  "v5.m2.decider.empreinte": "Empreinte relue : {{empreinte}}",
  "v5.m2.decider.irreversible": "La décision est inscrite au journal et ne se reprend pas.",
  "v5.m2.decider.lanceur": "Vous avez lancé cette mission : une autre personne habilitée décide.",
  "v5.m2.decider.partielle": "Décision partielle : tâches livrées {{livres}}, tâches abandonnées {{annules}}.",
  "v5.m2.decider.partielle_refusee": "Livraison partielle impossible : conditions non réunies.",
  "v5.m2.decider.portee": "Portée : la mission « {{mission}} » ({{taches}} tâches).",
  "v5.m2.decider.refuser": "Refuser",
  "v5.m2.decider.refuser_plan": "Refuser le plan",
  "v5.m2.decider.refuser_replan": "Refuser le nouveau découpage",
  "v5.m2.decider.resolution_dossier": "Résolution du dossier",
  "v5.m2.decider.rien_a_decider": "Cette mission n’attend aucune décision.",
  "v5.m2.decider.suite.abandonner": "Abandonner",
  "v5.m2.decider.suite.decider_le_dossier": "Décider le dossier",
  "v5.m2.decider.suite.libelle": "Suite",
  "v5.m2.decider.suite.prendre_acte_et_clore": "Prendre acte et clore",
  "v5.m2.decider.suite.replanifier": "Replanifier",
  "v5.m2.decider.tache_exclue": "La suite d’une tâche se décide depuis la fiche de la tâche.",
  "v5.m2.decider.titre": "Décider le plan ou le dossier d’une mission",
  "v5.m2.decider.version.deja_decide": "rien à décider",
  "v5.m2.decider.version.dossier": "dossier de mission à décider",
  "v5.m2.decider.version.nouveau_decoupage": "nouveau découpage proposé",
  "v5.m2.decider.version.plan_initial": "plan initial proposé",
  "v5.m2.decider.version.suite": "arrêts à traiter",
  "v5.m2.decider.version_relue": "Version relue",
  "v5.m2.ecran_non_realise": "« {{ecran}} » mène à un écran qui n’est pas encore disponible.",
  "v5.m2.etape.aucun": "Aucun événement.",
  "v5.m2.etape.aucun_de_l_etape": "Aucun événement de cette étape.",
  "v5.m2.etape.cible": "Cible",
  "v5.m2.etape.cible_absente": "Aucune cible reçue.",
  "v5.m2.etape.cible_recue": "Mission {{mission}}, tâche {{tache}}, étape {{etape}}.",
  "v5.m2.etape.etape": "Étape",
  "v5.m2.etape.etape_recue": "Étape reçue : {{etape}}",
  "v5.m2.etape.evenements": "Événements de l’étape",
  "v5.m2.etape.flux.connecte": "Flux connecté.",
  "v5.m2.etape.flux.connexion": "Connexion au flux…",
  "v5.m2.etape.flux.deconnecte": "Flux déconnecté.",
  "v5.m2.etape.flux.erreur": "Le flux a échoué.",
  "v5.m2.etape.flux.refus": "Accès au flux refusé.",
  "v5.m2.etape.incoherence": "La cible du traitement diffère de la cible reçue : la cible reçue est gardée.",
  "v5.m2.etape.reconnecter": "Reconnecter",
  "v5.m2.etape.retour_journal": "Retour au journal ({{filtre}})",
  "v5.m2.etape.sans_correlation": "{{nombre}} événements sans identifiants de mission, tâche ou étape.",
  "v5.m2.etape.tache": "Fiche de la tâche",
  "v5.m2.etape.titre": "Événements d’une étape de tâche",
  "v5.m2.etape.traitement": "le traitement",
  "v5.m2.etape.traitement_complet": "Traitement complet",
  "v5.m2.etape.traitement_etat": "Traitement {{id}} — {{statut}}",
  "v5.m2.etat.chargement": "Chargement : {{quoi}}…",
  "v5.m2.etat.en_cours": "En cours…",
  "v5.m2.etat.erreur": "Impossible de lire : {{quoi}}.",
  "v5.m2.etat.introuvable": "Introuvable : {{quoi}}.",
  "v5.m2.etat.reessayer": "Réessayer",
  "v5.m2.etat.refus": "Accès refusé : {{quoi}}.",
  "v5.m2.executer.approuver_outil": "Approuver l’exécution",
  "v5.m2.executer.bloquee": "Étape bloquée : prérequis absents.",
  "v5.m2.executer.commentaire": "Commentaire",
  "v5.m2.executer.echec": "L’étape n’a pas pu être lancée.",
  "v5.m2.executer.enfilee": "Étape mise en file ({{traitement}}).",
  "v5.m2.executer.environnement_docker": "Environnement Docker",
  "v5.m2.executer.etape": "Étape",
  "v5.m2.executer.etape_inconnue": "L’étape « {{etape}} » n’existe pas dans le processus du projet.",
  "v5.m2.executer.executer": "Exécuter",
  "v5.m2.executer.modele": "Gabarit {{modele}}, version {{version}} (figés).",
  "v5.m2.executer.outil_decide": "Décision sur l’outil enregistrée.",
  "v5.m2.executer.outil_demande": "Outil {{outil}}, proposé par {{auteur}}.",
  "v5.m2.executer.outil_echec": "La décision sur l’outil a échoué.",
  "v5.m2.executer.outil_ia": "Exécution d’un outil d’IA",
  "v5.m2.executer.pipeline": "Pipeline du projet",
  "v5.m2.executer.plan": "le processus du projet",
  "v5.m2.executer.prerequis_complets": "Prérequis complets.",
  "v5.m2.executer.reference_gitlab": "Référence GitLab",
  "v5.m2.executer.rejeter_outil": "Rejeter l’exécution",
  "v5.m2.executer.resultat": "Résultat attendu : {{nature}}.",
  "v5.m2.executer.sans_etape": "Aucune étape n’est désignée : ouvrez ce dialogue depuis une étape.",
  "v5.m2.executer.titre": "Exécuter une étape du projet",
  "v5.m2.executer.version": "Version à déployer",
  "v5.m2.fermer": "Fermer",
  "v5.m2.fiche_tache.aucune_tentative": "Aucune tentative.",
  "v5.m2.fiche_tache.avis": "{{nombre}} avis de revue (avis seulement, sans effet).",
  "v5.m2.fiche_tache.avis_absent": "Aucun avis de revue.",
  "v5.m2.fiche_tache.decider": "Décider la suite",
  "v5.m2.fiche_tache.empreinte": "Empreinte : {{empreinte}}",
  "v5.m2.fiche_tache.etape_inconnue": "Étape non identifiée.",
  "v5.m2.fiche_tache.etat_resultat.echec_demarrage": "échec au démarrage",
  "v5.m2.fiche_tache.etat_resultat.echoue": "échoué",
  "v5.m2.fiche_tache.etat_resultat.non_mesure": "non mesuré",
  "v5.m2.fiche_tache.etat_resultat.reussi": "réussi",
  "v5.m2.fiche_tache.evenements_etape": "Événements de l’étape",
  "v5.m2.fiche_tache.non_mesure": "Aucun résultat mesuré.",
  "v5.m2.fiche_tache.origine": "Origine de la suite",
  "v5.m2.fiche_tache.origine_absente": "Aucune décision n’a relancé cette tâche.",
  "v5.m2.fiche_tache.origine_decision": "Relancée par {{decideur}} ({{resolution}}) le {{le}}.",
  "v5.m2.fiche_tache.piece_absente": "Aucune pièce d’échec navigateur.",
  "v5.m2.fiche_tache.preuves": "Preuves",
  "v5.m2.fiche_tache.preuves_non_deposees": "Preuves non déposées.",
  "v5.m2.fiche_tache.resultat": "Tour {{tour}} — {{type}}",
  "v5.m2.fiche_tache.resultats": "Résultats",
  "v5.m2.fiche_tache.retour_mission": "Retour à la mission",
  "v5.m2.fiche_tache.suite_suspecte": "Suite de tests suspecte : {{motifs}}",
  "v5.m2.fiche_tache.tentative": "Tour {{tour}} — {{type}} ({{caste}})",
  "v5.m2.fiche_tache.tentatives": "Tentatives",
  "v5.m2.fiche_tache.titre": "Tâche de mission et preuves",
  "v5.m2.fiche_tache.traitement": "Voir le traitement",
  "v5.m2.mission.libelle": "la mission",
  "v5.m2.motif": "Motif",
  "v5.m2.motif_court": "Le motif doit compter {{min}} caractères au moins.",
  "v5.m2.motif_requis": "Le motif est requis.",
  "v5.m2.partage.actif": "Actif jusqu’au {{echeance}}",
  "v5.m2.partage.aucun_lien": "Aucun lien de partage.",
  "v5.m2.partage.cree": "Lien créé : {{chemin}}",
  "v5.m2.partage.creer": "Créer le lien",
  "v5.m2.partage.duree": "Durée (heures)",
  "v5.m2.partage.duree_aide": "{{defaut}} h par défaut, {{max}} h au plus.",
  "v5.m2.partage.duree_invalide": "Saisissez un nombre entier d’heures, {{min}} au moins.",
  "v5.m2.partage.echec": "Le lien n’a pas pu être créé.",
  "v5.m2.partage.expire": "Expiré le {{echeance}}",
  "v5.m2.partage.liens": "Liens de partage",
  "v5.m2.partage.ouvrir": "Ouvrir le lien {{id}}",
  "v5.m2.partage.plafond": "La durée dépasse le plafond de {{max}} h.",
  "v5.m2.partage.portee.connexion": "Le lien exige une connexion.",
  "v5.m2.partage.portee.expiration": "Le lien expire à l’échéance choisie.",
  "v5.m2.partage.portee.jeton": "Le lien ne porte aucun jeton.",
  "v5.m2.partage.portee.membres": "Seuls les membres actifs du projet l’ouvrent.",
  "v5.m2.partage.portee.revocable": "Le lien peut être révoqué.",
  "v5.m2.partage.revoque": "Révoqué (échéance {{echeance}})",
  "v5.m2.partage.titre": "Partager un aperçu",
  "v5.m2.piloter.arreter": "Arrêter",
  "v5.m2.piloter.confirmer_effet": "L’étape en cours finit, puis la mission s’arrête définitivement.",
  "v5.m2.piloter.confirmer_titre": "Arrêter la mission « {{mission}} » ?",
  "v5.m2.piloter.deja_terminee": "La mission est terminée.",
  "v5.m2.piloter.echec": "La demande a échoué.",
  "v5.m2.piloter.effets": "L’étape en cours finit ; rien d’autre ne démarre tant que la mission est suspendue ou arrêtée.",
  "v5.m2.piloter.etat": "État de la mission",
  "v5.m2.piloter.etat.en_cours": "en cours",
  "v5.m2.piloter.etat.ia_interrompue": "suspendue par l’outil",
  "v5.m2.piloter.etat.suspendu": "en pause",
  "v5.m2.piloter.etat.termine": "terminée",
  "v5.m2.piloter.fait": "Demande prise en compte.",
  "v5.m2.piloter.pas_en_cours": "La mission n’est pas en cours.",
  "v5.m2.piloter.pas_en_pause": "La mission n’est pas en pause.",
  "v5.m2.piloter.reprendre": "Reprendre",
  "v5.m2.piloter.reprise_automatique": "L’outil reprendra la mission quand la ressource sera disponible.",
  "v5.m2.piloter.suspendre": "Suspendre",
  "v5.m2.piloter.titre": "Piloter l’exécution d’une mission",
  "v5.m2.retours.aucun": "Aucun retour.",
  "v5.m2.retours.aucune_generation": "Aucune génération.",
  "v5.m2.retours.generation": "Génération",
  "v5.m2.retours.generations": "les générations",
  "v5.m2.retours.liste": "Retours",
  "v5.m2.retours.note": "Note {{note}} sur 5",
  "v5.m2.retours.nouveau": "Nouveau retour",
  "v5.m2.retours.ouvrir": "Ouvrir le retour {{id}}",
  "v5.m2.retours.sans_commentaire": "Sans commentaire",
  "v5.m2.retours.titre": "Retours sur les générations",
  "v5.m2.retours.toutes": "Toutes",
  "v5.m2.revision.acces": "Aperçus vivants : {{vivants}} sur {{plafond}} ; pool de ports {{pool}}.",
  "v5.m2.revision.acces_libelle": "l’accès",
  "v5.m2.revision.apercus": "Aperçus de la révision",
  "v5.m2.revision.application": "Application",
  "v5.m2.revision.aucun_apercu": "Aucun aperçu de cette révision.",
  "v5.m2.revision.aucune_autre": "Aucune autre révision de cette application.",
  "v5.m2.revision.base": "Révision de base",
  "v5.m2.revision.capture": "la capture",
  "v5.m2.revision.capture_absente": "Aucune capture.",
  "v5.m2.revision.capture_alt": "Capture de l’écran {{ecran}} à {{largeur}} px",
  "v5.m2.revision.carte": "Carte",
  "v5.m2.revision.comparaison_echec": "La comparaison a échoué.",
  "v5.m2.revision.comparer": "Comparer",
  "v5.m2.revision.comparer_titre": "Comparer deux révisions",
  "v5.m2.revision.date": "Date",
  "v5.m2.revision.demarre": "Aperçu demandé ({{id}}).",
  "v5.m2.revision.demarrer": "Démarrer un aperçu",
  "v5.m2.revision.ecarts": "Écrans identiques {{identical}}, changés {{changed}}, retirés {{removed}}, ajoutés {{added}}.",
  "v5.m2.revision.echec": "L’aperçu n’a pas pu démarrer.",
  "v5.m2.revision.effets": "Démarre l’application {{application}} à la révision {{revision}} exactement.",
  "v5.m2.revision.empreinte": "Empreinte",
  "v5.m2.revision.existant": "Un aperçu vivant de cette révision existe déjà.",
  "v5.m2.revision.identite": "Identité de la révision",
  "v5.m2.revision.introuvable": "Cette révision est introuvable pour l’application choisie.",
  "v5.m2.revision.libelle": "les révisions",
  "v5.m2.revision.modele": "Modèle",
  "v5.m2.revision.non_previsualisable": "Cette révision n’a pas passé ses contrôles.",
  "v5.m2.revision.origine": "Origine",
  "v5.m2.revision.origine.generation": "génération",
  "v5.m2.revision.origine.mission": "mission",
  "v5.m2.revision.ouvrir_apercu": "Ouvrir l’aperçu",
  "v5.m2.revision.plafond": "Le plafond d’aperçus vivants du projet est atteint.",
  "v5.m2.revision.publication": "Publication du code",
  "v5.m2.revision.releve": "Relevé",
  "v5.m2.revision.releve_absent": "Aucun relevé pour cette révision.",
  "v5.m2.revision.releve_resume": "{{ecrans}} écrans, {{routes}} routes relevés.",
  "v5.m2.revision.revision": "Révision",
  "v5.m2.revision.titre": "Révision d’une version d’essai",
  "v5.m2.sans_projet": "Aucun projet n’est choisi : ouvrez cet écran depuis un projet.",
  "v5.m2.suite.ajouter_etape": "Ajouter une étape",
  "v5.m2.suite.aucune_execution": "Aucune exécution.",
  "v5.m2.suite.auteur": "Définie par {{qui}} le {{le}}.",
  "v5.m2.suite.auteur_n_execute_pas": "Vous avez défini cette suite : un autre membre l’exécute.",
  "v5.m2.suite.commande_etape": "Commande de l’étape {{rang}}",
  "v5.m2.suite.confirmer_effet": "{{nombre}} commandes s’exécuteront dans l’ordre.",
  "v5.m2.suite.confirmer_titre": "Exécuter la suite « {{suite}} » ?",
  "v5.m2.suite.creation": "Définissez les commandes, dans l’ordre où elles s’exécuteront.",
  "v5.m2.suite.creee": "Suite créée.",
  "v5.m2.suite.creer": "Créer la suite",
  "v5.m2.suite.echec_creation": "La suite n’a pas pu être créée.",
  "v5.m2.suite.echec_execution": "L’exécution n’a pas pu être demandée.",
  "v5.m2.suite.effets": "{{nombre}} commandes s’exécutent dans l’ordre sur l’environnement du projet.",
  "v5.m2.suite.executee": "Exécution demandée (n° {{execution}}).",
  "v5.m2.suite.executer": "Exécuter la suite",
  "v5.m2.suite.executions": "Exécutions",
  "v5.m2.suite.introuvable": "Suite de commandes introuvable.",
  "v5.m2.suite.libelle": "la suite",
  "v5.m2.suite.nom": "Nom de la suite",
  "v5.m2.suite.nom_etape": "Nom de l’étape {{rang}}",
  "v5.m2.suite.nom_invalide": "Le nom ne prend que lettres, chiffres, espaces, points, tirets et soulignés (120 au plus).",
  "v5.m2.suite.nom_requis": "Le nom est requis.",
  "v5.m2.suite.ouvrir_execution": "Ouvrir l’exécution",
  "v5.m2.suite.relais": "Vous ne tenez pas le droit de définir les commandes : demandez à un membre qui le tient.",
  "v5.m2.suite.relais_lien": "Voir les membres du projet",
  "v5.m2.suite.relais_membre": "Demander à un autre membre",
  "v5.m2.suite.requis": "Requis.",
  "v5.m2.suite.retour": "Retour aux suites",
  "v5.m2.suite.statut.done": "terminée",
  "v5.m2.suite.statut.failed": "échouée",
  "v5.m2.suite.statut.pending": "en cours",
  "v5.m2.suite.statut.skipped": "sautée",
  "v5.m2.suite.titre": "Détail d’une suite de commandes",
  "v5.m2.suite.titre_creation": "Nouvelle suite de commandes",
  "v5.m2.suites.aucune": "Aucune suite de commandes.",
  "v5.m2.suites.creer": "Créer une suite",
  "v5.m2.suites.etapes": "{{nombre}} étapes",
  "v5.m2.suites.liste": "Suites du projet",
  "v5.m2.suites.preparer": "Préparer une suite",
  "v5.m2.suites.relais": "Créer une suite demande le droit de définir les commandes : demandez à un membre qui le tient.",
  "v5.m2.suites.titre": "Suites de commandes",
  "v5.m2.supervision.actions": "Actions",
  "v5.m2.supervision.agent": "Agent",
  "v5.m2.supervision.agents": "Agents en cours d’exécution",
  "v5.m2.supervision.agregation": "Agrégation",
  "v5.m2.supervision.aucun_executant": "Aucun agent en cours d’exécution.",
  "v5.m2.supervision.aucune_mission": "Aucune mission.",
  "v5.m2.supervision.consommation": "Consommation de calcul",
  "v5.m2.supervision.depuis": "Depuis",
  "v5.m2.supervision.dernier_signal": "Dernier signal",
  "v5.m2.supervision.erreur": "Erreur",
  "v5.m2.supervision.executant_a_choisir": "Choisissez un agent pour voir son exécution.",
  "v5.m2.supervision.execution": "Exécution",
  "v5.m2.supervision.journal": "Journal des traitements",
  "v5.m2.supervision.lancer_mission": "Lancer une mission",
  "v5.m2.supervision.ligne_caste": "{{caste}} : {{tours}} tours",
  "v5.m2.supervision.ligne_mission": "{{mission}} : {{consomme}} min consommées sur {{estime}} estimées",
  "v5.m2.supervision.ligne_tache": "Tâche {{rang}} — {{titre}} : {{tours}} tours, {{estime}} min estimées",
  "v5.m2.supervision.ligne_tours": "{{tours}} tours consommés (plafond {{plafond}} par tâche).",
  "v5.m2.supervision.mission": "Mission",
  "v5.m2.supervision.mission_a_choisir": "Choisissez une mission pour cette agrégation.",
  "v5.m2.supervision.missions": "les missions",
  "v5.m2.supervision.non_instrumente": "Traces de consommation non instrumentées.",
  "v5.m2.supervision.ouvrir_mission": "Ouvrir la mission",
  "v5.m2.supervision.statut": "Statut",
  "v5.m2.supervision.statut.error": "en erreur",
  "v5.m2.supervision.statut.idle": "au repos",
  "v5.m2.supervision.statut.running": "en cours",
  "v5.m2.supervision.titre": "Supervision des agents",
  "v5.m2.supervision.toutes": "Toutes",
  "v5.m2.supervision.voir_executant": "Voir l’exécutant {{agent}}",
  "v5.m2.supervision.vue.par_caste": "Par caste",
  "v5.m2.supervision.vue.par_mission": "Par mission",
  "v5.m2.supervision.vue.par_tache": "Par tâche",
  "v5.m2.supervision.vue.par_tour": "Par tour",
  "v5.m2.tache.cible": "Tâche visée",
  "v5.m2.tache.confirmer": "Confirmer la suite",
  "v5.m2.tache.consommation": "Calcul consommé par la tâche : {{secondes}} s.",
  "v5.m2.tache.decider_titre": "Décider la suite d’une tâche arrêtée",
  "v5.m2.tache.effet.accept_stop": "Le travail de la tâche est écarté ; les tâches qui en dépendent sont annoncées.",
  "v5.m2.tache.effet.other_family": "Le travail fait est conservé ; une autre famille de modèle reprend.",
  "v5.m2.tache.effet.redesign_tests": "Les tests sont reconçus avant une nouvelle tentative.",
  "v5.m2.tache.effet.reorient": "Le travail fait est conservé ; une nouvelle tentative s’ouvre.",
  "v5.m2.tache.effet.take_over": "Le travail fait est conservé ; une personne reprend la tâche.",
  "v5.m2.tache.lanceur": "Vous avez lancé la mission : un tiers habilité décide la suite.",
  "v5.m2.tache.libelle": "la tâche",
  "v5.m2.tache.limites": "Réouvertures déjà faites : {{reouvertures}} ; escalades restantes : {{restantes}}.",
  "v5.m2.tache.motif_arret": "Motif de l’arrêt : {{motif}}",
  "v5.m2.tache.pas_en_attente": "La tâche n’attend pas de décision.",
  "v5.m2.tache.portee": "Mission « {{mission}} », tâche {{tache}} (non modifiable).",
  "v5.m2.tache.portee_limitee": "La décision porte sur cette tâche seule, jamais sur toute la mission.",
  "v5.m2.tache.rang": "Tâche {{rang}} — {{titre}}",
  "v5.m2.tache.relais_tiers": "Demander à un membre habilité",
  "v5.m2.tache.reouverture_epuisee": "Le budget de réouvertures est épuisé : choisissez de prendre la main ou de prendre acte.",
  "v5.m2.tache.statut.cancelled": "annulée",
  "v5.m2.tache.statut.pending": "en attente",
  "v5.m2.tache.statut.ready": "prête",
  "v5.m2.tache.statut.running": "en cours",
  "v5.m2.tache.statut.stopped": "arrêtée",
  "v5.m2.tache.statut.succeeded": "terminée",
  "v5.m2.tache.suite": "Suite de la tâche",
  "v5.m2.tache.suite.autre_famille": "Autre famille de modèle",
  "v5.m2.tache.suite.prendre_acte_de_l_arret": "Prendre acte de l’arrêt",
  "v5.m2.tache.suite.prendre_la_main": "Prendre la main",
  "v5.m2.tache.suite.reconcevoir_les_tests": "Reconcevoir les tests",
  "v5.m2.tache.suite.reorienter": "Réorienter",
  "v5.m2.tests.acceptee": "acceptée",
  "v5.m2.tests.accepter": "Accepter la régression",
  "v5.m2.tests.anomalie_liee": "Anomalie liée",
  "v5.m2.tests.aucun_cas": "Aucun cas de test.",
  "v5.m2.tests.aucun_essai": "Aucun essai hors campagne.",
  "v5.m2.tests.aucun_plan": "Aucun plan de test.",
  "v5.m2.tests.aucune_campagne": "Aucune campagne.",
  "v5.m2.tests.aucune_quarantaine": "Aucun test en quarantaine.",
  "v5.m2.tests.aucune_reference": "Aucune campagne de référence éligible.",
  "v5.m2.tests.aucune_regression": "Aucune régression.",
  "v5.m2.tests.aucune_suite": "Aucun plan n’est désigné comme suite de non-régression.",
  "v5.m2.tests.campagne.cancelled": "annulée",
  "v5.m2.tests.campagne.closed": "clôturée",
  "v5.m2.tests.campagne.open": "ouverte",
  "v5.m2.tests.campagne_courante": "Campagne courante",
  "v5.m2.tests.campagne_terminee": "La campagne est terminée.",
  "v5.m2.tests.campagnes": "les campagnes",
  "v5.m2.tests.cas": "les cas",
  "v5.m2.tests.choisir": "Choisir…",
  "v5.m2.tests.choisir_campagne": "Choisissez une campagne courante.",
  "v5.m2.tests.comparaison_impossible": "Comparaison impossible pour cette campagne.",
  "v5.m2.tests.couverture": "Couverture",
  "v5.m2.tests.declarer": "Déclarer une anomalie",
  "v5.m2.tests.demarrer_essai": "Démarrer un essai",
  "v5.m2.tests.designer_suite": "Désigner la suite",
  "v5.m2.tests.en_quarantaine": "en quarantaine",
  "v5.m2.tests.essai.cancelled": "annulé",
  "v5.m2.tests.essai.failed": "échoué",
  "v5.m2.tests.essai.passed": "réussi",
  "v5.m2.tests.essai.running": "en cours",
  "v5.m2.tests.essais": "les essais",
  "v5.m2.tests.etat_cas.a_revalider": "à revalider",
  "v5.m2.tests.etat_cas.brouillon": "brouillon",
  "v5.m2.tests.etat_cas.executable": "exécutable",
  "v5.m2.tests.import_echec": "L’import a échoué.",
  "v5.m2.tests.importer": "Importer",
  "v5.m2.tests.importer_titre": "Importer les cas d’un traitement",
  "v5.m2.tests.importes": "{{nombre}} cas importés.",
  "v5.m2.tests.jamais_reussi": "Un test en quarantaine n’est jamais compté réussi.",
  "v5.m2.tests.lever": "Lever la quarantaine de {{cas}}",
  "v5.m2.tests.ligne_quarantaine": "{{cas}} — {{motif}} ({{qui}}, {{le}})",
  "v5.m2.tests.membres": "Membres du projet",
  "v5.m2.tests.mettre_en_quarantaine": "Mettre en quarantaine",
  "v5.m2.tests.motif_quarantaine": "Motif de la quarantaine",
  "v5.m2.tests.nombre_cas": "{{nombre}} cas",
  "v5.m2.tests.non_acceptee": "non acceptée",
  "v5.m2.tests.nouveau_cas": "Nouveau cas",
  "v5.m2.tests.nouveau_plan": "Nouveau plan",
  "v5.m2.tests.onglet.campagnes": "Campagnes",
  "v5.m2.tests.onglet.cas": "Cas",
  "v5.m2.tests.onglet.essais": "Essais hors campagne",
  "v5.m2.tests.onglet.plans": "Plans",
  "v5.m2.tests.onglet.regression": "Rapport de régression",
  "v5.m2.tests.onglet.tnr": "Suite de non-régression",
  "v5.m2.tests.onglets": "Vues des tests",
  "v5.m2.tests.ouvrir_plan_suite": "Ouvrir le plan de la suite",
  "v5.m2.tests.ouvrir_resultat": "Ouvrir le résultat",
  "v5.m2.tests.plan.active": "publié",
  "v5.m2.tests.plan.archived": "archivé",
  "v5.m2.tests.plan.draft": "brouillon",
  "v5.m2.tests.plans": "les plans",
  "v5.m2.tests.quarantaine": "Quarantaine",
  "v5.m2.tests.quarantaine_echec": "La quarantaine n’a pas pu être modifiée.",
  "v5.m2.tests.quarantaine_levee": "Quarantaine levée.",
  "v5.m2.tests.quarantaine_posee": "Quarantaine posée.",
  "v5.m2.tests.rapport": "le rapport de régression",
  "v5.m2.tests.rattacher": "Rattacher {{nombre}} cas à un plan",
  "v5.m2.tests.reference": "Référence : campagne n° {{id}}.",
  "v5.m2.tests.reference_a_choisir": "Référence : choisissez d’abord la campagne courante.",
  "v5.m2.tests.relance_echec": "La relance a échoué.",
  "v5.m2.tests.relance_en_file": "Relance mise en file.",
  "v5.m2.tests.relancer": "Relancer {{cas}}",
  "v5.m2.tests.resume_regressions": "{{non_acceptees}} régressions non acceptées, {{acceptees}} acceptées.",
  "v5.m2.tests.selection_vide": "Sélectionnez au moins un cas.",
  "v5.m2.tests.selectionner": "Sélectionner {{cas}}",
  "v5.m2.tests.suite": "la suite de non-régression",
  "v5.m2.tests.suite_plan": "Plan « {{nom}} », {{nombre}} cas inclus.",
  "v5.m2.tests.titre": "Tests",
  "v5.m2.tests.traitement": "Identifiant du traitement",
  "v5.m2.tests.traitement_requis": "Saisissez l’identifiant du traitement."
}
